import React from 'react';
import PropTypes from 'prop-types';

const RevenueCard = ({
  hasRevenueData,
  revenueChartData,
  revenueData,
  milestoneData,
  formatCurrencyOrDash,
}) => (
  <div className={`card revenue-card ${hasRevenueData ? 'with-data' : 'no-data'}`}>
    <div className="card-header">
      <h3 className="card-title">Revenue</h3>
      <span className="divider" />
    </div>
    <div className="card-content">
      <div className="revenue-layout">
        <div className="revenue-chart display-none">
          <svg viewBox="0 0 84.7 84.7" className="donut-svg">
            <circle
              cx="42.35"
              cy="42.35"
              r="38.35"
              fill="none"
              stroke="#E1E6FE"
              strokeWidth="8"
              strokeLinecap="round"
            />
            <circle
              cx="42.35"
              cy="42.35"
              r="38.35"
              fill="none"
              stroke="#848AF5"
              strokeWidth="8"
              strokeDasharray={revenueChartData?.strokeDasharray || '0 240'}
              strokeDashoffset="0"
              transform="rotate(-90 42.35 42.35)"
              strokeLinecap="round"
            />
            <text x="42.35" y="47" textAnchor="middle" className="donut-text">
              {revenueChartData?.displayPercentage || '0%'}
            </text>
          </svg>
        </div>

        <div className="revenue-info">
          <div className="revenue-item">
            <div className="revenue-indicator purple" />
            <div className="revenue-text">
              <span className="revenue-label">Total revenue (INR)</span>
              <span className="revenue-value">
                {hasRevenueData ? formatCurrencyOrDash(revenueData?.totalRevenue) : '-'}
              </span>
            </div>
          </div>
          <div className="revenue-item">
            <div className="revenue-indicator light-purple" />
            <div className="revenue-text">
              <span className="revenue-label">Invoice amount (INR)</span>
              <span className="revenue-value">
                {hasRevenueData ? formatCurrencyOrDash(revenueData?.invoiceAmount) : '-'}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="revenue-milestone display-none">
        <span className="milestone-label">No. of milestones completed:</span>
        <span className="milestone-value">{milestoneData?.display || '-'}</span>
      </div>
    </div>
  </div>
);

export default RevenueCard;

RevenueCard.propTypes = {
  hasRevenueData: PropTypes.bool.isRequired,
  revenueChartData: PropTypes.shape({
    strokeDasharray: PropTypes.string,
    displayPercentage: PropTypes.string,
  }),
  revenueData: PropTypes.shape({
    totalRevenue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    invoiceAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  milestoneData: PropTypes.shape({
    display: PropTypes.string,
  }),
  formatCurrencyOrDash: PropTypes.func.isRequired,
};

RevenueCard.defaultProps = {
  revenueChartData: null,
  revenueData: null,
  milestoneData: null,
};
